import React from "react";

export default function Skeleton() {
  return (
    <div className="animate-pulse p-4 flex space-x-4">
      <div className="flex-1 space-y-4 py-1">
        <div className="h-4 bg-gray-400  w-3/4"></div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-400 "></div>
          <div className="h-4 bg-gray-400  w-5/6"></div>
        </div>
      </div>
    </div>
  );
}
